<div class="pure-g m-b-12">
  <div class="pure-u-md-12-24 pure-u-lg-16-24">
    <h3 class="inline m-r-4">Multiple Eqp - Vessel Shop</h3>
  </div>
  <div class="pure-u-md-12-24 pure-u-lg-8-24 right">
    @if (canManageVesselWoProcessing) {
      <mc-button
        label="Upload"
        appearance="primary"
        fit="small"
        (click)="onOpenUploadDrawer()"
        (keydown.space)="$event.preventDefault(); onOpenUploadDrawer()">
      </mc-button>
    }
  </div>
</div>

<div class="vessel-wo-container">
  <div class="table-container">
    @if (data.length > 0 || isLoading) {
      <mc-table
        fit="small"
        data-cy="vessel-wo-file-list"
        [data]="isLoading ? mockDataForLoadingAnimation : data"
        [columns]="columns"
        nowrap="true"
        height="100%">
        @if (!isLoading) {
          @for (item of data; track item.id) {
            <div [slot]="item.id + '_status'">
              <mc-tag [appearance]="statusAppearance(item.status)" [label]="item.status"></mc-tag>
            </div>
            <div [slot]="item.id + '_action'" class="action-buttons">
              @if (item.reportBlobFileName) {
                <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
                  <mc-button
                    slot="trigger"
                    fit="small"
                    label="Download report"
                    hiddenlabel
                    icon="tray-arrow-down"
                    appearance="neutral"
                    variant="plain"
                    [loading]="item.isDownloading"
                    [disabled]="item.isDownloading"
                    (click)="onDownloadClicked(item)"
                    (keydown.enter)="onDownloadClicked(item)"
                    (keydown.space)="onDownloadClicked(item)">
                  </mc-button>
                  <span>Download report</span>
                </mc-tooltip>
              } @else if (item.errorSummary) {
                <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
                  <mc-button
                    slot="trigger"
                    fit="small"
                    label="Error summary"
                    hiddenlabel
                    icon="info-circle"
                    appearance="neutral"
                    variant="plain">
                  </mc-button>
                  <span>{{ item.errorSummary }}</span>
                </mc-tooltip>
              } @else if (canRefresh(item)) {
                <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
                  <mc-button
                    slot="trigger"
                    fit="small"
                    label="Refresh"
                    hiddenlabel
                    icon="arrow-clockwise"
                    appearance="neutral"
                    variant="plain"
                    (click)="onRefreshClicked(item)"
                    (keydown.enter)="onRefreshClicked(item)"
                    (keydown.space)="onRefreshClicked(item)">
                  </mc-button>
                  <span>Refresh</span>
                </mc-tooltip>
              }
            </div>
          }
        }
        @if (isLoading) {
          @for (row of mockDataForLoadingAnimation; track row.id) {
            @for (column of columns; track column.id) {
              <div [slot]="row.id + '_' + column.id">
                <app-loader></app-loader>
              </div>
            }
          }
        }
      </mc-table>
    } @else {
      <div class="aems-card no-data">
        <p>Uploaded vessel work order files and their processing status will be available here.</p>
      </div>
    }
  </div>

  @if (data.length > 0) {
    <div class="pure-g m-t-16 footer">
      <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24">
        <mc-select
          style="width: 140px; display: block"
          [value]="pageLimit"
          optionswidth="100px"
          ngDefaultControl
          label="Per page"
          labelposition="left"
          fit="small"
          (optionselected)="onPageLimitChange($event)">
          @for (pageCount of [10, 20, 50, 100, 200]; track $index) {
            <mc-option [value]="pageCount">{{ pageCount }}</mc-option>
          }
        </mc-select>
      </div>
      <div class="pure-u-md-12-24 pure-u-lg-16-24 pure-u-xl-16-24 flex-container flex-center">
        <mc-pagination
          hiddenlabels
          [currentpage]="currentPage"
          [totalpages]="lastPage ?? 1"
          visiblepages="7"
          (pagechange)="onPageChange($event)"
          fit="small">
        </mc-pagination>
      </div>
      <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24 text-align-right">
        <span class="page-description" i18n>Showing {{ data.length }} of {{ totalItemCount }}</span>
      </div>
    </div>
  }
</div>

@if (isUploadDrawerOpen) {
  <app-vessel-wo-upload-drawer
    [open]="isUploadDrawerOpen"
    [vesselShops]="vesselShops"
    [isSubmitting]="isUploadingFile"
    (saved)="onUploadDrawerSaved($event)"
    (cancelled)="onUploadDrawerCancelled()">
  </app-vessel-wo-upload-drawer>
}
